module.exports = __webpack_public_path__ + "static/media/welcome.8411146d.jpg";